<ng-container *ngIf="showChrome; else plainChart">
  <div class="dashboard-widget-card">
    <app-widget-card-header
      [title]="widget.title"
      [isMockPreview]="isMockPreview"
      [isEditable]="isEditable"
      [canDelete]="canDelete"
      [isEditMode]="isEditMode"
      [sensorTypeLabels]="sensorTypeLabels"
      (edit)="edit.emit()"
      (remove)="remove.emit()">
    </app-widget-card-header>

    <div class="dashboard-widget-card__content">
      <ng-container *ngTemplateOutlet="plainChart"></ng-container>
    </div>
  </div>
</ng-container>

<ng-template #plainChart>
  <div *ngIf="hasNoData; else chartTpl" class="chart-no-data">
    <mat-icon class="chart-no-data__icon" aria-hidden="true">bar_chart</mat-icon>
    <span>Sin datos disponibles</span>
    <span class="chart-no-data__range" *ngIf="timeRangeLabel">{{ timeRangeLabel }}</span>
  </div>
  <ng-template #chartTpl>
    <highcharts-chart
      [Highcharts]="Highcharts"
      [options]="chartOptions"
      [(update)]="updateFlag"
      [oneToOne]="true"
      class="dashboard-widget-chart">
    </highcharts-chart>
  </ng-template>
</ng-template>
